// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ad3591d2","455":"b7e126b1","977":"5cdda785"}[chunkId] + ".chunk.js";
};